//
// Game Loader
//

Loader = {};
Loader.isLoaded = false;
Loader.minTimerExpired = false;
Loader.readyForSplash = false;
Loader.crtPercent = 0;

autoplayManager.containerName = "autoplayContainer:autoplayBackground";

Loader.initialise = function (container) {
  Loader.container = container;

  Loader.doTextMapping();

  // Setup callback functions
  resourceManager.registerLoadCompleteCallback(Loader.onLoadComplete);
  resourceManager.registerLoadProgressCallback(Loader.onLoadProgress);
  Reflex.registerEventHandler("ready", Loader.onLayoutComplete);
};

Loader.doTextMapping = function () {
  const isMobile = gdk.deviceInfo.mobile;

  if (isMobile) {
    gdk.addConfigValue("textReplacementContinue", "t_TouchToContinue");
    gdk.addConfigValue("textReplacementGamble", "t_touchWheelToGamble");
  } else {
    gdk.addConfigValue("textReplacementContinue", "t_ClickToContinue");
    gdk.addConfigValue("textReplacementGamble", "t_clickWheelToGamble");
  }
};

Loader.onResize = function (width, height, isLandscape) {
  if (Loader.loaderBackground !== undefined) {
    var scale = Math.max(
      width / Loader.loaderBackground.texture.width,
      height / Loader.loaderBackground.texture.height
    );
    Loader.loaderBackground.scale.x = scale;
    Loader.loaderBackground.scale.y = scale;
    Loader.loaderBackground.position.x = width / 2;
    Loader.loaderBackground.position.y = height / 2;
  }
};

Loader.onLoadComplete = function (loadGroup, resources) {
  if (loadGroup === "loading") {
    Loader.progressBar = resourceManager.get("loader:loadingProgressBack");
    resourceManager.getContainer("loadingContainer").visible = true;
    resourceManager.getContainer("backgroundContainer").visible = false;
    resourceManager.getContainer("splashContainer").visible = false;
    resourceManager.getContainer("maxPlayBackgroundContainer").visible = false;
    resourceManager.getContainer("fsBackgroundContainer").visible = false;
    resourceManager.getContainer("darkOverlayContainer").visible = true;

    Loader.loadMask = resourceManager.get("loader:loadingMask");
    Loader.loadMask.beginFill(0xffffff);
    Loader.loadMask.drawRect(0, 0, 474, 80);
    Loader.loadMask.endFill();

    Loader.loadMask.pivot.x = 0;
    Loader.loadMask.scale.x = 0;
    Loader.progressBar.mask = Loader.loadMask;

    Loader.setLoadProgress(0);

    Reflex.registerEventHandler("layoutChange", Loader.layoutChange);

    const loadingData = gdk.getPlatformLoadingData();
    let isGamCareLogoVisible = checkForDefined(loadingData.gamCareLogo)
      ? loadingData.gamCareLogo
      : false;
    let isPreloadMessageVisible = checkForDefined(loadingData.message);
    resourceManager.get("GamCareContainerPreLoad:gamCareLogo").visible =
      isGamCareLogoVisible;
    resourceManager
      .get("GamCareContainerPreLoad:preLoadMessage")
      .setText(isPreloadMessageVisible ? loadingData.message : "");
    resourceManager.get("GamCareContainerPreLoad").visible =
      isGamCareLogoVisible ||
      (isPreloadMessageVisible && loadingData.message.length != 0);

    if (isPreloadMessageVisible) {
      // YG requirement, we need to give player 5 seconds to read preloader message
      timerManager.addTimer(5000, undefined, function () {
        Loader.minTimerExpired = true;
        Loader.checkCanGoToSplash();
      });
    } else {
      Loader.minTimerExpired = true;
      Loader.checkCanGoToSplash();
    }
  }
};

Loader.layoutChange = function () {
  Loader.setLoadProgress(Loader.crtPercent);
};

Loader.onLoadProgress = function (percent, loadGroup) {
  if (loadGroup !== "loading") {
    Loader.crtPercent = percent;
    Loader.setLoadProgress(percent);
  }
};

Loader.onLayoutComplete = function () {
  Loader.setLoadProgress(1);
  gameData.screenDim = resourceManager.get("backgroundScreenDimObject");
};

Loader.onGameConfigEvent = function (gameConfigTask) {
  gameData.reels = [];

  gameData.reelAnimations = [];
  gameData.bonusSymbols = [];
  gameData.inputOverlord = resourceManager.getController("inputOverlord");
  gameData.inputOverlord.setState("disabled");
  gameData.slotConfig = gameConfigTask.data.slotConfig;

  gameData.maxExposure = gameConfigTask.data.maxExposure;

  if (gameConfigTask.data.savedClientData) {
    var encoreData = gameConfigTask.data.savedClientData.meta.find(function (
      element
    ) {
      return element.name === "encore";
    });
  }

  var enableEncoreButton = encoreData && encoreData.enabled;

  if (enableEncoreButton && !gameConfigTask.data.slotConfig.promotionActive) {
    // task.data.metaValue is set to true if recovering encore game
    gameData.encoreEnabled = true;

    // Put button in the right state if not already true
    var encoreButtonLB = resourceManager.get(
      "buttonContainer:buttonBar:luckyBetToggleButton"
    );

    if (encoreButtonLB._flags.showLuckyBetActive !== gameData.encoreEnabled) {
      encoreButtonLB.setRecovery();
    }

    resourceManager
      .getController("stakeController")
      .setStakeMultiplier(encoreData.value);
    game.changeStake(
      resourceManager.getController("stakeController").CurrentStake
    );
    game.resetWinnings();
    resourceManager.getController("stakeController").broadcastCurrentStake();
  }

  // Allow player to click through load screen
  let backgroundLandscape = resourceManager.get("splashBackgroundL");
  backgroundLandscape.setInteractiveCallbacks(function () {
    backgroundLandscape.interactive = false;
    gdk.loadingClosed();
    Reflex.updateViewport();
  }, true);

  let backgroundPortrait = resourceManager.get("splashBackgroundP");
  backgroundPortrait.setInteractiveCallbacks(function () {
    backgroundPortrait.interactive = false;
    gdk.loadingClosed();
    Reflex.updateViewport();
  }, true);

  gameData.slotConfig = gameConfigTask.data.slotConfig;

  game.stopDistances = gameConfigTask.data.stopDistances;

  // Link buttons to functions
  game.initialise(gameConfigTask);

  Loader.setStartingSymbols();

  var slotMachine = resourceManager.getController("SlotMachine");

  // All objects are created, so create game specific data
  for (var i = 0; i < slotMachine.reels.length; i++) {
    let reel = resourceManager.get("slotContainer:reelContainer:reel" + i);
    let startingSymbols = gameData.slotConfig.startingSymbols[i].symbols;
    let reelLength = gameData.slotConfig.startingSymbols[i].symbols.length;

    // Copy starting symbols from server
    for (var j = 0; j < reelLength; ++j) {
      reel.setReelSymbol(j, startingSymbols[j].value);
    }

    gameData.reels.push(reel);
  }

  Loader.readyForSplash = true;

  Loader.checkCanGoToSplash();
};

Loader.setStartingSymbols = function () {
  for (var i = 0; i < 5; i++) {
    var reel = resourceManager.get("slotContainer:reelContainer:reel" + i);
    var startingSymbols = gameData.slotConfig.startingSymbols[i].symbols;

    //Generate last reel positions, only the symbols in view are passed to us so we need to generate the pre/post apperature symbols
    var symbol;
    for (let j = 0; j < 4; ++j) {
      if (j < 3) symbol = +startingSymbols[j].value;
      else symbol = Math.floor(Math.random() * 7);
      reel.setReelSymbol(j, symbol);
    }
  }
};

Loader.checkCanGoToSplash = function () {
  if (Loader.readyForSplash && Loader.minTimerExpired) {
    Loader.readyForSplash = false;
    Loader.minTimerExpired = false;
    resourceManager.getContainer("loadingContainer").visible = false;
    resourceManager.getContainer("splashContainer").visible = true;
    game.goToSplash();
  }
};

Loader.setLoadProgress = function (percent) {
  Loader.loadMask.scale.x = percent;
};

messageBus.subscribe("spinner:GameConfigEvent", Loader.onGameConfigEvent);
